/**
 * Created by comoon on 1/25/16.
 */

var React = require("react");

var _ = require("underscore");

var moment = require("moment");

var QuoteApplyForm = require("../detail/QuoteApplyForm.jsx");

var ALikeStore = require("../store/ALikeStore");

var Dispatcher = require("../Dispatcher");

var QuoteStatus = require("../conf/quote-status");

var OrderStatus = require("../conf/order-status");

var OrderTarget = require("../conf/order-target");

var WalleTarget = require("../conf/walle-target");

var TripGrade = require("../conf/trip-grade");

var TripStatus = require("../conf/trip-status");

var RoleType = require("../conf/role-type");

var {ActionConstants, EventConstants} = require("../Constants");

var {object2class} = require("../util/clazz");

var {format} = require("../util/price");

var Countdown = require("../cutil/Countdown");

var Tip = require("../cutil/Tip");

var QuoteRecordList = require("../detail/QuoteRecordList");

var CATEGORY_MIN = 1;
var CATEGORY_MAX = 12;
var CATEGORY_STEP = 1;
var SELLER_MIN = 6;
var SELLER_MAX = 4888;
var SELLER_STEP = 7;
var PRODUCT_MIN = 45;
var PRODUCT_MAX = 100000;
var PRODUCT_STEP = 17;

var FRESH_QUOTE_INTERVAL =  120 * 1000;

/**
 *  按一定秒刷新询价列表
 */
var freshQuote = _.throttle(function () {

    Dispatcher.dispatch({type: ActionConstants.FRESH_QUOTE_RESULT_LIST});

},FRESH_QUOTE_INTERVAL);

module.exports = React.createClass({
    displayName: "QuoteAppB",
    getInitialState(){
        var props = this.props;
        var trip = ALikeStore.get_tripBasicInfo();
        var userRole = trip.userRole || 0;  //1: 达人, 2: 小帮手,0: 其他
        return {
            isOpenLoadingLayer:false,
            form: true,
            collapsed: false,
            categories: CATEGORY_MIN,
            sellers: SELLER_MIN,
            products: PRODUCT_MIN,
            _switched: null,
            _refreshed: null,
            orderStatus: null,
            ordering: false,
            tripInfo: trip,
            userRole: userRole
        }
    },
    handle_toggleCollapse(){
        var collapsed = !this.state.collapsed;
        this.setState({
            collapsed
        });
    },
    handle_selectVersion(versionId){

        Dispatcher.dispatch({
            type: ActionConstants.SWITCH_QUOTE_RECORD,
            data: {versionId}
        });
    },
    handle_tweak(){

        var quote = ALikeStore.get_recordDetail(ALikeStore.get_currentRecord());
        if( quote.grade === -1 ){
            quote.grade = 1
        }

        this.setState({form: true});
    },
    //预定,状态改变为等待付款
    handle_order(){
        var self = this;
        window.bookDialog.init(function(){
            var trip = self.state.tripInfo;
            if( !+trip.canOrderFlag ){
                $.cpWin.alert({
                    type:'hintErr',
                    msg: '该功能只限用户购买!'
                });
                return;
            }
            Dispatcher.dispatch({type: ActionConstants.ORDER});

            self.setState({ordering : true });
        })
    },
    handle_reorder(){
        if (!ALikeStore.get_errorMsg(ActionConstants.ORDER)) {
            window.location.href = OrderTarget.buyUrl.pc;
        }

    },
    handle_orderPayment(orderId){
        if (!ALikeStore.get_errorMsg(ActionConstants.ORDER)) {
            window.location.href = OrderTarget.orderUrl.pc + '?oid=' + orderId;
        }
    },
    handle_orderDetail(orderId){
        if (!ALikeStore.get_errorMsg(ActionConstants.ORDER)) {
            window.location.href = OrderTarget.orderDetaillUrl.pc + '?mid=' + orderId;
        }
    },
    handle_walleEdit(){
        var trip = ALikeStore.get_tripBasicInfo();
        var tripId = trip.tripId || null;
        if (tripId) {
            window.location.href = WalleTarget.walleEdit.url + '?tid=' + tripId;
        }
    },
    handle_sendTripUser(){
        var trip = this.state.tripInfo;
        var tripId = trip.tripId;
        Dispatcher.dispatch({type: ActionConstants.SEND_TRIP_USER});
    },
    componentWillMount(){

        freshQuote();
        setInterval(freshQuote,FRESH_QUOTE_INTERVAL)

        ALikeStore.on(EventConstants.AJAX_RETRIEVE_RECORD_LIST_COMPLETE, this.on_retrieveRecordListComplete);

        ALikeStore.on(EventConstants.ACTION_SWITCH_QUOTE_RECORD_COMPLETE, this.on_switchQuoteRecordComplete);

        ALikeStore.on(EventConstants.AJAX_ORDER_COMPLETE, this.on_orderComplete);

        ALikeStore.on(EventConstants.AJAX_SEND_TRIP_USER_COMPLETE, this.on_sendTripUserComplete);

    },
    componentDidMount(){
        return;
        var self = this;
        self.__categoryInterval = setInterval(function () {
            var categories = self.state.categories;
            categories = categories + CATEGORY_STEP;
            if (categories > CATEGORY_MAX) {
                categories = CATEGORY_MIN;
            }
            self.setState({categories});
        }, 3000);
        self.__sellerInterval = setInterval(function () {
            var sellers = self.state.sellers;
            sellers = sellers + SELLER_STEP;
            if (sellers > SELLER_MAX) {
                sellers = SELLER_MIN;
            }
            self.setState({sellers});
        }, 1000);
        self.__productInterval = setInterval(function () {
            var products = self.state.products;
            products = products + PRODUCT_STEP;
            if (products > PRODUCT_MAX) {
                products = PRODUCT_MIN;
            }
            self.setState({products});
        }, 1000);
    },
    componentWillUnmount(){
        ALikeStore.off(EventConstants.AJAX_RETRIEVE_RECORD_LIST_COMPLETE, this.on_retrieveRecordListComplete);

        ALikeStore.off(EventConstants.ACTION_SWITCH_QUOTE_RECORD_COMPLETE, this.on_switchQuoteRecordComplete);

        ALikeStore.off(EventConstants.AJAX_ORDER_COMPLETE, this.on_orderComplete);

        ALikeStore.off(EventConstants.AJAX_SEND_TRIP_USER_COMPLETE, this.on_sendTripUserComplete);

        clearTimeout(this.__categoryInterval);
        clearTimeout(this.__sellerInterval);
        clearTimeout(this.__productInterval);
    },
    handle_LoadingClose(){
        this.setState({
            isOpenLoadingLayer: false
        })
    },
    /**
     * poa显示日期和周几
     */
    handle_setWeekDay(){
        var quteItem = $(".quote-container-iml .qr-item.selected");
        if(quteItem.length){
            quteItem.eq(0).trigger("click");
        }
    },
    /**
     * 询价列表返回
     */
    on_retrieveRecordListComplete(){

        this.on_switchQuoteRecordComplete();
        /*var self = this;
        setTimeout(function(){
            self.handle_setWeekDay();
        },0)*/

    },
    /**
     * 切换询价选择后返回
     */
    on_switchQuoteRecordComplete(){

        var quote = ALikeStore.get_recordDetail(ALikeStore.get_currentRecord());

        if( !quote ){

            return

        }

        var isExpired = quote.isExpired;

        var orderStatus = quote.orderStatus;

        var isForm = function () {

            var isQuote = ALikeStore.is_quote( ALikeStore.get_currentRecord() );

            return isExpired && ! isQuote

        };

        if( quote.orderId===0 && quote.orderStatus!== OrderStatus.noOrder.code ){

            return;

        }

        this.setState({
            orderStatus: orderStatus,
            isExpired:isExpired,
            form: isForm(),
            categories: CATEGORY_MIN,
            sellers: SELLER_MIN,
            products: PRODUCT_MAX,
            _switched: new Date()
        });
    },
    on_quoteInvalid(info){
        Dispatcher.dispatch({
            type: ActionConstants.ALERT_QUOTE_BECOME_INVALID,
            data: info
        });
    },
    on_orderComplete(){

        if (!ALikeStore.get_errorMsg(ActionConstants.ORDER)) {

            window.location.href = ALikeStore.get_confirmUrl().web;
        }
    },
    on_sendTripUserComplete(){
        var errorMsg = ALikeStore.get_errorMsg(ActionConstants.SEND_TRIP_USER);

        if (errorMsg) {
            $.cpWin.alert({
                type:'hintErr',
                msg:errorMsg
            });
        }else{
            $.cpWin.alert({
                msg:'提交成功。',
                subHandle:function(){
                    $.cpReload();
                }
            });
        }
    },
    render(){

        //console.log("render bplan....")

        var self = this;

        var state = this.state;

        var tripStatus = state.tripInfo.tripStatus;

        var trip = ALikeStore.get_tripBasicInfo();

        var form = state.form;

        var expired = false;
        var quoteRecordList = ALikeStore.get_quoteRecordList();

        if (quoteRecordList.length === 0) {
            //如果没有任何返回的时候, 新提交的数据不能定位到当前组件
            //所以, 当没有任何数据时, 返回空的计价结果容器

            return (<div className="quote-container-iml"></div>);
        }
        var currentQuote = ALikeStore.get_recordDetail(ALikeStore.get_currentRecord());


        if (!state._switched) {
            //如果没有使用过切换功能,则不设置

            currentQuote = null;
        }

        if (currentQuote) {

            expired = currentQuote.isExpired;
        }


        var userRole = this.state.userRole;


        /**
         * 不显示询价记录:
         * 1/如果计价中(为用户时)
         * 2/审核未通过
         * 3/已付全款
         */
        return (
            <div className="quote-container-iml">
                {

                        self.render_quoteConditionDetail()
                }
                {((+tripStatus === TripStatus.Edit.code && userRole !== RoleType.expert.code ) || +tripStatus === TripStatus.Fail.code ||  currentQuote.orderStatus === OrderStatus.fullPayed.code) ? null : (
                    <div>
                        {self.render_collapseIndicator()}
                        <QuoteRecordList collapsed={state.collapsed} switched={ !!state._switched } />
                    </div>
                )}

            </div>
        );
    },

    /**
     * 取得当前询价状态
     */
    _getQuoteStatus: function(quote, version){
        var tripInfo = this.state.tripInfo;
        var tripStatus = tripInfo.tripStatus;
        var userRole = this.state.userRole;
        var hasBought = ALikeStore.is_tripHasBeenBought();

        var status = null;
        if(+tripStatus === 1){
            status = 6;
            return status
        }
        if(+tripStatus === 4){
            status = 8;
            return status;
        }

        if(+version.status === 1 ){
            status = 1;
            return status;
        }

        if(quote.isDateNear){
            status = 7;
            return status;
        }


        if(quote.isExpired){
            status = 4;
            return status;
        }

        if(quote.isAllMistake){
            status  = 3;
            return status;
        }

        if(+version.status === 2 ){
            status = 2;
            return status;
        }

        if(version.valid && (version.status===QuoteStatus.Normal.code || version.status===QuoteStatus.Mistake.code) ){
            //1:计价 2:报价
            status = quote.inquiryType==1 ? 9 : 10;
            return status;
        }

        /*if(version.price >0 && (+version.status==2 || +version.has_service == 0) ){
         status = 3;
         return status;
         }
         */

        //预定成功

        if (hasBought) {
            status = 5;
            return status;
        }

        return status;

    },
    /**
     * 判断询价状态,渲染
     */
    render_QuoteStatus: function(quote, version){
        var tripInfo = this.state.tripInfo;
        var tripStatus = tripInfo.tripStatus;
        var userRole = this.state.userRole;
        var hasBought = ALikeStore.is_tripHasBeenBought();

        //临近出行,只对计价有效
        var isDateNear = quote.isDateNear && quote.inquiryType==1;

        //达人正在修改
        /*if(+tripStatus === TripStatus.Edit.code){
            return this.render_quoteEditing(quote);
        }
        //达人审核不通过
        if(+tripStatus === TripStatus.Fail.code){
            return this.render_invalid(quote,version);
        }*/
        //计算中
        if(+version.status === QuoteStatus.Calculating.code ){
            return this.render_quoteCalculating(quote, version);
        }

        //价格临近过期
        if(isDateNear){
            return this.render_dateExpired(quote);
        }

        //价格过期
        if(quote.isExpired ){
            return this.render_priceExpired(quote);
        }

        //全部缺货
        if(quote.isAllMistake){
            return this.render_mistake(quote, version);
        }

        //计算失败,需要询价
        if(+version.status === QuoteStatus.Fatal.code || !version.valid){
            return this.render_failed(quote, version);
        }

        //正常报价
        if(version.valid && (version.status===QuoteStatus.Normal.code || version.status===QuoteStatus.Mistake.code)){
            //计价
            if(quote.inquiryType==1) {
                return this.render_valuation(quote, version);

            }else{
            //报价
                return this.render_enquiry(quote, version);

            }
        }

        return null;

    },
    /**
     * 展开收起
     * @returns {*}
     */
    render_collapseIndicator(){

        var state = this.state;

        var quoteRecordList = ALikeStore.get_quoteRecordList();

        if (quoteRecordList.length === 0) {

            return null;
        }
        return (state.collapsed ?
            (<div className="toggle-quote-result expand" onClick={this.handle_toggleCollapse}>
                展开<i className="icon-indicator-arr-r-d"/>
            </div>) :
            (<div className="toggle-quote-result collapse" onClick={this.handle_toggleCollapse}>
                收起<i className="icon-indicator-arr-l-d"/>
            </div>));
    },
    /**
     * 结果详情,报包: 出行条件 / 报价(过期/结果) / 计价(价格日历/结果)
     * @returns {XML}
     */
    render_quoteConditionDetail(){
        var userRole = this.state.userRole;

        var quote = ALikeStore.get_recordDetail(ALikeStore.get_currentRecord());

        var version = ALikeStore.get_versionDetail(ALikeStore.get_currentVersion());

        //var status = this._getQuoteStatus(quote, version);

        var tripStatus = this.state.tripInfo.tripStatus

        // >0时有订单了..
        var orderStatus  = this.state.orderStatus;

        //console.log("用户类型:1: 达人, 2: 小帮手,0: 其他(白名单)")
        //console.log("当前用户类型:",userRole)

        //console.log("1:计算中,2:需要询价,3:缺货,4:价格过期,5:已付款,6:修改中,7:日期过期,8:审核未过,9:计价正常,10:报价正常")
        //console.log("当前询价状态:",status)

        return (
            <div className="quote-record">

                {
                    !orderStatus ? (
                        (() => {
                            switch (tripStatus) {
                                case TripStatus.Edit.code:
                                    return this.render_quoteEditing(quote,version);
                                    break;

                                case TripStatus.Fail.code:
                                    return this.render_invalid(quote,null);
                                    break;

                                default:
                                    return this.render_QuoteStatus(quote, version)
                            }
                        })()
                    ) : (
                        this.render_orderStatus(quote, version)
                    )
                }
            </div>
        );
    },
    /**
     * 出行条件 detail > 条件
     * @param quote
     * @returns {XML}
     */
    render_quoteConditionList(quote){
        var trip = ALikeStore.get_tripBasicInfo();
        var carCnt  = trip.hasCar ? (`，<strong class="c-orange">${quote.carCnt}</strong> 辆车`) : null;
        return (
            <ul className="condition-list">
                <li className="condition-item">
                    <div className="content">
                        出发日期：
                        <span className="c-orange">
                            { quote.buyDate !== "" ? quote.buyDate : quote.startDate}
                        </span>
                    </div>
                    <div className="content">
                        出发城市：<span className="c-orange">{quote.startCityName}</span>
                    </div>
                </li>
                <li>
                    <div className="content">
                        <strong className="c-orange">{quote.adtCnt}</strong> 成人，
                        <strong className="c-orange">{quote.chdCnt}</strong> 儿童，
                        <strong className="c-orange">{quote.roomCnt}</strong> 间房
                        <span dangerouslySetInnerHTML={{__html: carCnt}}></span>
                    </div>
                </li>
            </ul>
        );
    },
    render_quoteNotResult(){

        var self = this;
        var state = self.state;


    },

    /**
     * 计价-->价格日历
     * @param quote
     * @param version
     * @returns {XML}
     */
    render_priceTable: function(quote, version){
        // this.props.priceTable(quote, version)
        var self = this;
        var trip = this.state.tripInfo;
        var inWhiteList = trip.inWhiteList || 0;
        //console.log("当前日历:",version)
        //console.log("日历list:",quote.priceCalenderDataList)
        var dataListLen = (quote && quote.priceCalenderDataList) ? quote.priceCalenderDataList.length : 0;
         return(
             <div className="price-table">
                 {_.map(_.range(0, dataListLen), function (order) {
                     var dayInfo = quote.priceCalenderDataList[order];

                     var date = moment(dayInfo.startDate);

                     if (!dayInfo || !dayInfo.versionId) {
                         return (
                             <div className="day-price" key={order}>
                                 <div>
                                     <span className="date">{date.format("MM-DD")}</span>
                                     &nbsp;<span className="day">{date.format("dd")}</span>
                                 </div>
                                 <span className="ask">计算中…</span>
                             </div>
                         );
                     }

                     var selected = false;
                     if( dayInfo.versionId ){

                         selected = dayInfo.versionId === version.versionId;

                     }else{

                         dayInfo.startDate === quote.startDate && (selected = true);

                     }

                     var dayPriceClazz = object2class({
                         "day-price": true,
                         "selected": selected
                     });
                     var isVersion = (dayInfo.versionId === version.versionId) ? true : false;
                     var lockClazz = object2class({
                         "lack": true,
                         "icon-indicator-lack-white": isVersion,
                         "icon-indicator-lack-gray": !isVersion
                     });
                     if(+dayInfo.hasService==0 && _.indexOf(dayInfo.tips,"行程大师六大服务包")===-1){
                         dayInfo.tips.push("行程大师六大服务包");
                     }

                     var tips = "";
                     if(+dayInfo.status === QuoteStatus.Fatal.code && inWhiteList){
                         tips = "除缺货商品外价格："+format(dayInfo.perPrice)+"（仅供内部使用，严禁泄露给用户）";
                     }
                     return (
                         <div className={dayPriceClazz} key={dayInfo.versionId + "-" + order}
                              onClick={()=>{self.handle_selectVersion(dayInfo.versionId)}}
                              data-startdate={dayInfo.startDate}
                              title={tips}
                         >
                             <div>
                                 <span className="date">{date.format("MM-DD")}</span>
                                 &nbsp;<span className="day">{date.format("dd")}</span>
                             </div>
                             <div>
                                 {   //缺货
                                     (+dayInfo.status === QuoteStatus.Mistake.code || +dayInfo.hasService==0) ?
                                         (
                                             (dayInfo.tips.length>0)?(
                                                 <Tip trigger={<i className={lockClazz}/>} enter>
                                                     {self.render_mistakeHint(dayInfo)}
                                                 </Tip>
                                             ):(
                                                 <i className={lockClazz}/>
                                             )
                                         ) : null
                                 }
                                 {
                                     (dayInfo.startDate === quote.startDate) ?
                                         (<span className="default-day">默认日期</span>) : null
                                 }

                             </div>
                             <div className="text-right">
                                 {
                                     (dayInfo.valid && +dayInfo.status!==QuoteStatus.Fatal.code) ?
                                         (<span className="price">￥{format(dayInfo.perPrice)}</span>) :
                                         (dayInfo.status === QuoteStatus.Calculating.code) ?
                                             (<span className="ask">计算中…</span>) : (
                                             <Tip trigger={<span className="ask">欢迎询价</span>} enter>
                                                 {self.render_quoteHint()}
                                             </Tip>
                                         )
                                 }
                             </div>
                         </div>
                     );
                 })}
             </div>
         )

    },

    /**
     * 计价/报价--->结果
     * @param quote
     * @param version
     * @returns {XML}
     */
    render_quoteResult: function(quote, version){
        var self = this;
        var state = self.state;
        var ordering = state.ordering;
        var userRole = state.userRole;
        return(
            <div>
            {
                (version.valid && +version.status!==QuoteStatus.Fatal.code) ?
                (<div className="version-op">
                    <div className="mod-price">
                        <div>
                            <strong className="f-l">人均：</strong>
                            <span className="price f-xl">{format(version.perPrice)}</span>
                            <span className="c-orange f-18">&nbsp;元</span>
                        </div>
                        <div>
                            ( 总价：<span className="total-price f-18">￥{format(version.amount)}</span> )
                        </div>
                    </div>
                    {(+version.status === QuoteStatus.Mistake.code || +version.hasService==0) ? (
                        <div className="error-msg"><i className="icon-indicator-tip-gray"></i>
                            <a href="#priceUncontain" className="js-anchor"><span className="f-normal c-blue">&nbsp;&nbsp;此价格不包含以下旅行产品</span></a>
                        </div>
                    ) : null}

                    <div>
                        <div className="error-msg">{ALikeStore.get_errorMsg(ActionConstants.ORDER)}</div>
                        {
                            userRole !== RoleType.expert.code ? (
                                !ordering ? (
                                    <button className="btn btn-orange" onClick={self.handle_order}>开始预定</button>
                                ) : (
                                    <button className="btn btn-orange" >预定中…</button>
                                )
                            ):(
                                null
                            )
                        }
                        <a href="https://www.xcds.com.cn/topic/special/price_ratio/?rf=zhunaa" className="btn-blue btn-price-ratio magic-elment" target="_blank">
                            <i className="icon icon-super-detail-price-ratio"></i>
                            全网比价，超全攻略
                        </a>
                    </div>
                    <div className="count-down">计价剩余有效时间:&nbsp;
                        <Countdown onInvalid={self.on_quoteInvalid}
                                   data={quote}
                                   left={ALikeStore.get_recordInvalidSeconds(quote.inquiryKey)}
                                   minuteText="分"/>
                    </div>
                </div>) : null
            }
            </div>
        )
    },
    /**
     * 联系方式
     * @returns {XML}
     */
    render_contact(isShowTel, isShowIM){
        var isShowTel = isShowTel || false;
        var isShowIM = isShowIM || false;
        return (
            <div className="contact magic-elment">
                {isShowTel? (
                    <div className="vm-wrapper tel">
                        <i className="icon-indicator-tel"/>
                        <span>&nbsp;&nbsp;4006-86-5060</span>
                    </div>
                ) : null}

                {isShowIM ? (
                    this.render_im()
                ): null}
            </div>
        );
    },
    /**
     * 计价提示
     * @returns {XML}
     */
    render_quoteHint(){
        return (
            <div className="c-tip-content quote-hint-box">
                <div className="c-head">
                    <i className="icon-indicator-sigh"/>
                    询价提示
                </div>
                <div className="c-body">
                    <div>
                        为了保证价格真实有效，当日价格需要申请实时询价。
                        你可拨打4006-86-5060或在线出询价要求。
                    </div>
                    <div className="methods">
                        <div className="method m1">
                            <div className="title">
                                <span className="hint">方式01</span>
                                <span>&nbsp;:&nbsp;</span>
                                <span>在线咨询</span>
                            </div>
                              {this.render_im()}
                        </div>
                        <div className="method m2">
                            <div className="title">
                                <span className="hint">方式02</span>
                                <span>&nbsp;:&nbsp;</span>
                                <span>在线咨询</span>
                            </div>
                            <div className="vm-wrapper tel">
                                <i className="icon-indicator-tel"/>
                                <span>&nbsp;&nbsp;4006-86-5060</span>
                            </div>
                        </div>
                    </div>
                    <div className="note">
                        ＊询价结果将会第一时间发送到你的手机或在登录页面刷新后
                    </div>
                </div>
            </div>
        );
    },
    render_mistakeHint(dayInfo){
        var tips = dayInfo.tips;
        if(tips.length == 0){
            return;
        }
        return(
            <div className="quote-lack-info">
                <label className="title c-blue"><i className="icon-indicator-sigh"></i>&nbsp;&nbsp;该日期缺少产品</label>
                <ul className="lack-list">
                    {
                        _.map(tips, function(item, index){
                            return(
                                <li className="lack-item" key={index}>
                                    <div className="lack-txt"><i className="icon-indicator-lack-gray"></i>&nbsp;&nbsp;<span dangerouslySetInnerHTML={{__html: item}}></span></div>
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
        )
    },
    /**
     * 未提交或者达人修改中
     */
    render_quoteEditing: function(quote, version){
        var userRole = this.state.userRole;
        var self = this;

        var trip = ALikeStore.get_tripBasicInfo();
        var saveStep  = +trip.saveStep || 0;

        var tipsInfo = (saveStep == 1 || saveStep == 2 ) ? '方案已修改但商品信息没有再次确认保存，请返回修改' : '方案还未提交，请立即提交方案';

        //此处写的...达人显示提交给用户浮层
        if(userRole === RoleType.expert.code){
            $("div.js_bottom_panel").show();
        }

        return(
            <div>
                {
                    userRole !== RoleType.expert.code ? (
                        <div>
                            <div className="quote-wait"><i className="icon-indicator-wait"></i>
                                <div className="wait-txt f-l">达人正在调整方案，完成后可以进行预定，有任何问题可以联系旅行顾问</div>
                            </div>
                            <div className="calc-status">
                                <div className="version-op">
                                    {self.render_contact(true, true)}
                                </div>
                            </div>
                        </div>
                    ):(
                        <div>
                            <div className="quote-condition">
                                {this.render_quoteConditionList(quote)}
                            </div>
                            <div className="calc-status">
                                { quote.inquiryType===1 ? (
                                    <div>
                                        {this.render_priceTable(quote, version)}
                                        {this.render_quoteResult(quote, version)}
                                    </div>
                                ):(
                                    <div>
                                        {this.render_quoteResult(quote, version)}
                                    </div>
                                )}
                                <div className="version-op">
                                    <div className="wait-txt f-l">{tipsInfo}</div>
                                    <button className="btn btn-blue"  onClick={this.handle_walleEdit}>编辑方案</button>
                                    {
                                        (saveStep == 1 || saveStep == 2 ) ? (
                                            <button className="btn btn-orange" disabled>提交给用户</button>
                                        ) : (
                                            <button className="btn btn-orange" onClick={this.handle_sendTripUser}>提交给用户</button>
                                        )
                                    }

                                </div>
                            </div>
                        </div>

                    )
                }
            </div>
        )
    },
    /**
     * 已提交计算中
     */
    render_quoteCalculating: function(quote, version){
        var userRole = this.state.userRole;
        var self = this;
        return(
            <div>
                <div className="quote-condition">
                    {this.render_quoteConditionList(quote)}
                </div>
                {
                    userRole !== RoleType.expert.code ? (
                        <div className="calc-status">
                            {this.render_priceTable(quote, version)}
                            <div className="version-op">
                                <div className="strong-hint">计算中...</div>
                                <div className="status-info f-normal">正在计价中，请耐心等待，有任何问题可以联系旅行顾问	</div>
                                {self.render_contact(true, true)}
                            </div>
                        </div>
                    ):(
                        <div className="calc-status">
                            {this.render_priceTable(quote, version)}
                            <div className="version-op">
                                <div className="strong-hint">计算中...</div>
                                <div className="status-info f-normal">正在计价中，请耐心等待</div>
                            </div>
                        </div>
                    )
                }
            </div>

        )
    },

    /**
     * 计算完成-全部缺货,
     */
    render_mistake: function(quote, version){
        var userRole = this.state.userRole;
        var self = this;
        return(
            <div>
                {
                    userRole !== RoleType.expert.code ? (
                         <div>
                             <div className="quote-condition">
                                 {this.render_quoteConditionList(quote)}
                             </div>
                            <div className="calc-status">
                                {this.render_priceTable(quote, version)}
                                <div className="version-op">
                                    <div className="status-info f-normal">该出发日期缺少<a href="#priceUncontain" id="link-key" className="js-anchor">关键产品</a>，将会影响行程安排，请联系旅行顾问询价	</div>
                                    {self.render_contact(true, true)}
                                </div>
                            </div>
                         </div>
                    ):(

                        <div>
                            <div className="quote-condition">
                                {this.render_quoteConditionList(quote)}
                            </div>
                            <div className="calc-status">
                                {this.render_priceTable(quote, version)}
                                <div className="version-op">
                                    <div className="status-info f-normal">您对用户有什么留言，可以直接在线沟通	</div>
                                    {self.render_contact(false, true)}
                                </div>
                            </div>
                        </div>

                    )
                }
            </div>
        )
    },

    render_question: function(){
        return (
            <div className="status-info f-normal status-question">
                <i className="icon-indicator-tip-gray"></i>
                <span>本产品为全自动实时计价产品，不能进行单品价格的拆分。有任何问题，可以联系旅行顾问</span>
            </div>
        )
    },

    /**
     * 日期临近失效
     */
    render_dateExpired: function(quote){
        var userRole = this.state.userRole;
        var self = this;
        return(
            <div>
                {
                    userRole !== RoleType.expert.code ? (
                        <div>
                            <div className="quote-wait"><i className="icon-indicator-wait"></i>
                                <div className="wait-txt f-l">您所选择的出发日期{moment(quote.startDate).format("YYYY[年]MM[月]DD[日]")}临近出行,请联系旅行顾问沟通签证等旅行证件准备情况.</div>
                            </div>
                            <div className="calc-status">
                                <div className="version-op">
                                    {self.render_question()}
                                    {self.render_contact(true, true)}
                                </div>
                            </div>
                        </div>
                    ):(
                        <div>
                            <div className="quote-wait"><i className="icon-indicator-wait"></i>
                                <div className="wait-txt f-l">客户所选择的出发日期{moment(quote.startDate).format("YYYY[年]MM[月]DD[日]")}临近出行,请联系客户沟通签证等旅行证件准备情况.</div>
                            </div>
                            <div className="calc-status">
                                <div className="version-op">
                                    <div className="status-info f-normal"><i className="icon-indicator-tip-gray"></i>&nbsp;&nbsp;您对用户有什么留言，可以直接在线沟通</div>
                                    {self.render_contact(false, true)}
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>
        )
    },
    /**
     * 价格过期失效
     */
    render_priceExpired: function(quote){
        var userRole = this.state.userRole;
        var self = this;
        return(
            <div>
                <div className="quote-condition">
                    {this.render_quoteConditionList(quote)}
                </div>
                <div className="calc-status">
                    <div className="version-op b-top">
                        <div className="strong-hint">价格已过期</div>
                        {
                            userRole !== RoleType.expert.code? (
                                <div>
                                { quote.inquiryType==1 ? (
                                    <div>
                                        <div className="status-info f-normal">
                                            <i className="icon-indicator-tip-gray"></i><span>&nbsp;&nbsp;已停止自动计价（用户访问时会触发重启！）</span>
                                        </div>
                                        {self.render_contact(true, true)}
                                    </div>
                                ): (
                                    <div>
                                        {self.render_question()}
                                        {self.render_contact(false, true)}
                                    </div>
                                )}
                                </div>
                            ):(
                                <div>
                                    { quote.inquiryType==1 ? (
                                        <div>
                                            <div className="status-info f-normal">
                                                <i className="icon-indicator-tip-gray"></i><span>&nbsp;&nbsp;因为机票等旅行产品价格波动，为保证获得最佳价格，请重新计价</span>
                                            </div>
                                            {self.render_contact(true, true)}
                                        </div>
                                    ): (
                                        <div>
                                            <div className="status-info f-normal">
                                                <i className="icon-indicator-tip-gray"></i><span>&nbsp;&nbsp;您对用户有什么留言，可以直接在线沟通</span>
                                            </div>
                                            {self.render_contact(false, true)}
                                        </div>

                                    )}
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        )
    },
    /**
     * 计算失败,需要询价
     */
    render_failed: function(quote, version){
        var userRole = this.state.userRole;
        var self = this;
        return(
            <div>
                <div className="quote-condition">
                    {this.render_quoteConditionList(quote)}
                </div>
                {
                    userRole !== RoleType.expert.code ? (

                        <div className="calc-status">
                            {this.render_priceTable(quote, version)}
                            <div className="version-op">
                                <div className="strong-hint">欢迎询价</div>
                                <div className="status-info f-normal"><i className="icon-indicator-tip-gray"></i>&nbsp;&nbsp;该出发日期缺少<a href="#priceUncontain" id="link-key" className="js-anchor">关键产品</a>,将会影响行程安排,你可拨打4006-86-5060联系旅行顾问询价</div>
                            </div>
                            <div className="version-op b-top">
                                {self.render_contact(true, true)}
                            </div>
                        </div>
                    ):(

                        <div className="calc-status">
                            {this.render_priceTable(quote, version)}

                            <div className="version-op b-top">
                                <div className="strong-hint">欢迎询价</div>
                                <div className="status-info f-normal"><i className="icon-indicator-tip-gray"></i>&nbsp;&nbsp;该出发日期缺少<a href="#priceUncontain" id="link-key" className="js-anchor">关键产品</a>,将会影响行程安排,你可拨打4006-86-5060联系旅行顾问询价</div>
                                {self.render_contact(false, true)}
                            </div>
                        </div>
                    )
                }
            </div>
        )
    },
    /**
     * 审核未过
     */
    render_invalid: function(quote,version){
        var userRole = this.state.userRole;
        var self = this;
        return(

            <div>
                <div className="quote-condition">
                    {this.render_quoteConditionList(quote,version)}
                </div>

                {
                    userRole !== RoleType.expert.code ? (
                    <div>
                        <div className="quote-wait"><i className="icon-indicator-wait"></i>
                            <div className="strong-hint">审核未通过</div>
                            <div className="wait-txt f-l">有任何问题，可以联系旅行顾问</div>
                        </div>
                        <div className="calc-status">
                            <div className="version-op">
                                {self.render_contact(true, true)}
                            </div>
                        </div>
                    </div>
                    ):(
                    <div>
                        <div className="quote-wait"><i className="icon-indicator-wait"></i>
                            <div className="strong-hint">审核未通过</div>
                            <div className="wait-txt f-l">方案存在需要调整的地方，请调整后再次提交</div>
                        </div>
                        <div className="calc-status">
                            <div className="version-op">
                                {self.render_contact(false, true)}
                            </div>
                        </div>
                    </div>
                    )
                }

            </div>

        )
    },

    /**
     * 计价--正常
     */
    render_valuation: function(quote, version){
        var userRole = this.state.userRole;
        var self = this;

        return(
            <div>
                <div className="quote-condition">
                    {this.render_quoteConditionList(quote)}
                </div>
            {
                userRole !== RoleType.expert.code ? (

                    <div className="calc-status">
                        {this.render_priceTable(quote, version)}
                        {this.render_quoteResult(quote, version)}

                        <div className="version-op b-top">
                            {self.render_question()}
                            {self.render_contact(true, true)}
                        </div>
                    </div>
                ):(

                    <div className="calc-status">
                        {this.render_priceTable(quote, version)}
                        {this.render_quoteResult(quote, version)}

                        <div className="version-op b-top">
                            <div className="status-info f-normal"><i className="icon-indicator-tip-gray"></i>&nbsp;&nbsp;您对用户有什么留言，可以直接在线沟通</div>
                            {self.render_contact(false, true)}
                        </div>
                    </div>
                )
            }
            </div>

        )
    },
    /**
     * 报价--正常
     */
    render_enquiry: function(quote, version){
        var userRole = this.state.userRole;
        var self = this;

        return(
            <div>
                <div className="quote-condition">
                    {this.render_quoteConditionList(quote)}
                </div>
                {
                    userRole !== RoleType.expert.code? (

                        <div className="calc-status">
                            {this.render_quoteResult(quote, version)}

                            <div className="version-op b-top">
                                {self.render_question()}
                                {self.render_contact(true, true)}
                            </div>
                        </div>

                    ):(

                        <div className="calc-status">
                            {this.render_quoteResult(quote, version)}

                            <div className="version-op b-top">
                                <div className="status-info f-normal"><i className="icon-indicator-tip-gray"></i>&nbsp;&nbsp;您对用户有什么留言，可以直接在线沟通</div>
                                {self.render_contact(false, true)}
                            </div>
                        </div>

                    )
                }
            </div>
        )
    },
    /**
     * 报价/记价状态
     * @param quote
     * @param version
     * @returns {XML}
     */
    render_orderStatus(quote, version){
        var userRole = this.state.userRole;
        var self = this;
        if(quote.orderStatus === OrderStatus.fullPayed.code){
            var orderFullPayed = this.render_orderFullPayed(quote);
            return orderFullPayed
        }
        return(
            <div>
                <div>
                    <div className="quote-condition">
                        {this.render_quoteConditionList(quote)}
                    </div>
                    {
                        userRole !== RoleType.expert.code ? (

                            <div className="calc-status">
                                {this.render_orderDetail(quote, version)}

                                <div className="version-op b-top">
                                    {self.render_question()}
                                    {self.render_contact(true, true)}
                                </div>
                            </div>
                        ):(

                            <div className="calc-status">
                                {this.render_orderDetail(quote, version)}

                                <div className="version-op b-top">
                                    <div className="status-info f-normal"><i className="icon-indicator-tip-gray"></i>&nbsp;&nbsp;您对用户有什么留言，可以直接在线沟通</div>
                                    {self.render_contact(false, true)}
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        )
    },
    /**
     * 报价/记价状态--->结果
     * @param quote
     * @param version
     * @returns {XML}
     */
    render_orderDetail(quote,version){

        var self = this;
        return (
            <div>
                {
                    version.valid && +version.status !== QuoteStatus.Fatal.code ?
                        (<div className="version-op">
                            <div className="mod-price">
                                <div>
                                    <strong className="f-l">人均：</strong>
                                    <span className="price f-xl">{format(version.perPrice)}</span>
                                    <span className="c-orange f-18">&nbsp;元</span>
                                </div>
                                <div>
                                    ( 总价：<span className="total-price f-18">￥{format(version.amount)}</span> )
                                </div>
                            </div>
                            <div>
                                {self.render_orderButton(quote)}
                            </div>
                        </div>) : null
                }

            </div>
        )
    },
    /**
     * 渲染状态
     * @param quote
     * @returns {XML}
     */
    render_orderButton(quote){
        var self = this;
        var state = self.state;
        var orderStatus  = state.orderStatus;
        //var orderStatus  = 4
        //console.log("订单状态3...",orderStatus)
        return(
            <div>

                {(() => {
                    switch (orderStatus) {

                        case OrderStatus.waitingForPay.code:
                            return (
                                <span>
                                    <button className="btn btn-orange" onClick={ ()=>{self.handle_orderPayment(quote.orderId)}}>已下预定单，立即付款</button>
                                    <br/>
                                    <button className="btn btn-default bt-reorder" onClick={self.handle_reorder }>关闭已下预定单</button>
                                </span>
                            );
                            break;

                        case OrderStatus.partPayed.code:

                            $("div.js_buttom_fullpayed_panel").show();

                            return(
                                <div>
                                    <div className="strong-hint">已付定金</div>
                                    <button className="btn btn-orange" onClick={ ()=>{self.handle_orderPayment(quote.orderId)}}>支付尾款</button>
                                </div>
                            );
                            break;

                        case OrderStatus.fullPayed.code:
                            return(
                                <div>
                                    <div className="strong-hint">已付全款</div>
                                    <button className="btn btn-orange"  onClick={ self.handle_reorder }>查看订单状态</button>
                                </div>
                            );
                            break;

                        case OrderStatus.tradeClose.code:
                            return(
                                <div>
                                    <div className="strong-hint">交易关闭</div>
                                    <button className="btn btn-orange" onClick={ self.handle_reorder }>查看订单状态</button>
                                </div>
                            );
                            break;

                        default:
                            return null;
                    }
                })()}
            </div>
        )
    },
    /**
     * 付全款
     * @param quote
     * @returns {XML}
     */
    render_orderFullPayed(quote){
        //如果是用户显示提示
        var userRole = this.state.userRole;
        $("div.js_buttom_fullpayed_panel").show();

        var self = this;
        var trip = ALikeStore.get_tripBasicInfo();
        var carCnt  = trip.hasCar ? (`，<strong class="c-orange">${quote.carCnt}</strong> 辆车`) : null;
        return(
            <div>
                <div className="quote-condition">
                    <div className="strong-hint">旅行方案已预定</div>
                    <div className="strong-hint"></div>
                    <ul className="condition-list">
                        <li className="condition-item">
                            <div className="content">
                                出发日期：
                                <span className="c-orange">
                                    { quote.buyDate !== "" ? quote.buyDate : quote.startDate}
                                </span>
                            </div>
                        </li>
                        <li>
                            <div className="content">
                                <strong className="c-orange">{quote.adtCnt}</strong> 成人，
                                <strong className="c-orange">{quote.chdCnt}</strong> 儿童，
                                <strong className="c-orange">{quote.roomCnt}</strong> 间房
                                <span dangerouslySetInnerHTML={{__html: carCnt}}></span>
                            </div>
                        </li>
                    </ul>
                </div>
                <div className="calc-status">
                    <div className="version-op">
                        <button className="btn btn-orange"  onClick={  ()=>{self.handle_orderDetail(quote.orderId)} }>查看预定信息</button>
                    </div>
                </div>
            </div>
        )
    },
    /**
     * 渲染IM按钮
     * @returns {XML}
     */
    render_im(){
        var trip = this.state.tripInfo;
        var chatId  = trip.chatId;
        var chatUser  = trip.chatUser;
        var dataId = chatId ? chatId : chatUser;

        return(
            <div>
                {!chatId ? (
                    <i className="icon-btn-talk webim-online-click tl-im" data-id={dataId}/>
                ): (
                    <i className="icon-btn-talk webim-groupchat-link tl-im" data-chatid={dataId}/>
                )}
            </div>
        )
    }

});
 



/** WEBPACK FOOTER **
 ** ./script/detail-b/QuoteApp.jsx
 **/